import { Link } from 'react-router-dom';
import PublicNav from '../components/PublicNav';
import PageMeta from '../components/PageMeta';
import Footer from '../components/Footer';
import BLOG_POSTS from '../content/blogPosts';

export default function BlogIndex() {
  return (
    <div className="page">
      <PageMeta
        title="Blog"
        description="Personal finance insights and guides from the Agence team."
        path="/blog/"
      />
      <PublicNav />
      <main>
        <div className="blog-wrap">
          <p className="blog-page-label">Agence Blog</p>
          <h1 className="blog-h1">Finance, clearly.</h1>
          <p className="blog-subtitle">Guides and insights on managing your money with AI.</p>

          <ul className="blog-post-list">
            {BLOG_POSTS.map(post => (
              <li key={post.slug}>
                <Link to={`/blog/${post.slug}`} className="blog-post-card">
                  <p className="blog-post-tag">{post.tag}</p>
                  <h2 className="blog-post-title">{post.title}</h2>
                  <p className="blog-post-excerpt">{post.excerpt}</p>
                  <p className="blog-post-meta">{post.displayDate} &nbsp;·&nbsp; {post.readTime}</p>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </main>
      <Footer />
    </div>
  );
}
